import { Button, Modal } from 'react-bootstrap';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { deleteSeance } from 'src/store/actions/seance-actions';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';
import { ISeance } from 'src/types/seance';

interface Props {
    data: ISeance;
}

const DeleteSeanceAction: React.FunctionComponent<Props> = ({ data: { id } }: Props) => {
    const dispatch = useDispatch();
    const [opened, setOpened] = useState(false);
    const handleClose = () => {
        setOpened(false);
    };

    /* eslint-disable */
    /* eslint jsx-a11y/anchor-is-valid: 0 */

    /* eslint-enable */
    return (
        <>
            <button
                style={{ background: '#d3d3d3' }}
                type="button"
                onClick={() => setOpened(true)}
                className="btn btn-secondary mb-1"
            >
                <FontAwesomeIcon icon={faTrash} /> session
            </button>
            <Modal show={opened} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {' '}
                    <p style={{ marginBottom: 0 }}>Are you sure you want to cancel this session?</p>
                    <p style={{ marginBottom: 0 }}> Session will be permanently removed.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        No
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() =>
                            dispatch(
                                deleteSeance(id, handleClose, (errorMessage: string) => {
                                    handleClose();
                                    toast.error(errorMessage);
                                }),
                            )
                        }
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default DeleteSeanceAction;
